import { AddService as DefinitionAddService } from '@app/admin/activity-groups/definition/add/services/add.service';
import { AddService as VehicleTypeAddService } from '@app/admin/activity-groups/vehicle-type/add/services/add.service';
import { DetailService as DefinitionDetailService } from '@app/admin/activity-groups/definition/detail/services/detail.service';
import { DetailService as VehicleTypeDetailService } from '@app/admin/activity-groups/vehicle-type/detail/services/detail.service';
import { Routes } from '@angular/router';

export const activityGroupsRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('@app/admin/activity-groups/activity-groups.component').then(component => component.ActivityGroupsComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'definition',
      },
      {
        path: 'definition',
        children: [
          {
            path: '',
            children: [
              {
                path: '',
                loadComponent: () => import('@app/admin/activity-groups/definition/overview/overview.component').then(component => component.OverviewComponent),
              },
            ],
          },
          {
            path: 'add',
            providers: [DefinitionAddService],
            children: [
              {
                path: '',
                loadComponent: () => import('@app/admin/activity-groups/definition/add/add.component').then(component => component.AddComponent),
              },
            ],
          },
          {
            path: ':id',
            providers: [DefinitionDetailService],
            children: [
              {
                path: '',
                loadComponent: () => import('@app/admin/activity-groups/definition/detail/detail.component').then(component => component.DetailComponent),
              },
            ],
          },
        ],
      },
      {
        path: 'vehicle-type',
        children: [
          {
            path: '',
            children: [
              {
                path: '',
                loadComponent: () => import('@app/admin/activity-groups/vehicle-type/overview/overview.component').then(component => component.OverviewComponent),
              },
            ],
          },
          {
            path: 'add',
            providers: [VehicleTypeAddService],
            children: [
              {
                path: '',
                loadComponent: () => import('@app/admin/activity-groups/vehicle-type/add/add.component').then(component => component.AddComponent),
              },
            ],
          },
          {
            path: ':id',
            providers: [VehicleTypeDetailService],
            children: [
              {
                path: '',
                loadComponent: () => import('@app/admin/activity-groups/vehicle-type/detail/detail.component').then(component => component.DetailComponent),
              },
            ],
          },
        ],
      },
    ],
  },
];
